import { useCallback } from "react"
import { graphql, useMutation, UseMutationConfig } from "react-relay"
import { useChDeleteLegalGuardianAttestationMutation as useChDeleteLegalGuardianAttestationMutationType } from "@/modules/patients/detail/legal-guardian-attestation/ch/services/__generated__/useChDeleteLegalGuardianAttestationMutation.graphql"

const mutation = graphql`
  mutation useChDeleteLegalGuardianAttestationMutation($input: Ch_deleteAttestationGuardianInput!) {
    ch_deleteAttestationGuardian(input: $input) {
      ch_AttestationGuardian {
        id @deleteRecord
      }
    }
  }
`

const useChDeleteLegalGuardianAttestationMutation = () => {
  const [commit, isFlight] = useMutation<useChDeleteLegalGuardianAttestationMutationType>(mutation)

  const commitHandler = useCallback(
    (config: UseMutationConfig<useChDeleteLegalGuardianAttestationMutationType>) => {
      commit(config)
    },
    [commit],
  )

  return [commitHandler, isFlight] as const
}

export { useChDeleteLegalGuardianAttestationMutation }
